import { PaymentPlan } from '@sworkit/api';

export function trackFacebookCompleteRegistration() {
  if (!window['fbq']) return;
  window['fbq']('track', 'CompleteRegistration');
}

export function trackFacebookAddToCart(plan: PaymentPlan) {
  if (!window['fbq'] || !plan) return;
  window['fbq']('track', 'AddToCart', {
    value: convertPriceToNumber(plan.price),
    order_quantity: 1,
    currency: plan.currency,
    line_items: [
      {
        product_id: plan.purchaseID,
      },
    ],
  });
}

export function trackFacebookPurchase(
  price: string,
  currency: string,
  product_id: string
) {
  if (!window['fbq']) return;
  window['fbq']('track', 'Purchase', {
    value: convertPriceToNumber(price),
    order_quantity: 1,
    currency,
    line_items: [
      {
        product_id,
      },
    ],
  });
}

function convertPriceToNumber(priceString: string) {
  const removeDollar = priceString.replace('$', '');
  const priceNumber = Number(removeDollar);
  if (isNaN(priceNumber)) {
    return null;
  } else {
    return priceNumber;
  }
}
